import React from "react";
import "./about.css";
import {
  FaFacebookF,
  FaTelegram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import profilePic from "../assets/emil-dark.jpg"; // make sure path is correct

export default function About() {
  return (
    <section id="about" className="about">
      {/* Left side – Photo */}
      <div className="about-photo">
        <img src={profilePic} alt="Emil Risko" />
      </div>

      {/* Right side – Text */}
      <div className="about-text">
        <h2>Who am I?</h2>
        <p>
         I’m a Front-End Developer who recently completed a professional course in front-end development. My academic background is in software engineering, with a university degree focused on automation systems.
           <br/>
         Now, I’m excited to shift my focus back to programming and apply my technical and analytical skills to web development. I’m passionate about creating clean, responsive user interfaces and continuously improving as a developer.
        </p>
       <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=100004117207787" target="_blank" rel="noreferrer"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/in/emil-risko-02ab012a0" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
              <a href="https://wa.me/+36301783757"><FaWhatsapp /></a>
              <a href="https://t.me/emilrisko"><FaTelegram /></a>
            </div>
      </div>
        
    </section>
  );
}
